import { useAppState } from 'AppProvider';
import type { IStorefrontSettings } from 'types/brandSettings.types';

const NO_STOREFRONT: IStorefrontSettings = { pages: [], rootCatalogId: null };

/**
 * The brand's storefront settings from the public settings already loaded into app state: the
 * root catalog (Browse) and the other top-level pages. A brand without them answers no root and
 * no pages, so callers need no null checks.
 */
const useStorefrontSettings = (): IStorefrontSettings => {
  const { settings } = useAppState(
    (state: Record<string, unknown>) => state.brand,
  );
  const stored = settings?.storefront as
    | Partial<IStorefrontSettings>
    | undefined;
  if (!stored) return NO_STOREFRONT;
  return {
    pages: stored.pages ?? [],
    rootCatalogId: stored.rootCatalogId ?? null,
  };
};

export default useStorefrontSettings;
